import React, { FormEvent, useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../redux/actions/modal";
import ButtonLoader from "../../../UI/Loaders/Loaders";
import CustomSearchDropDown from "../../../components/CustomHTMLElements/CustomSearchDropDown/CustomSearchableDropdown";
import useAllRoleCategories from "../../../custom-hooks/useRoleCategories";
import useAllRoleByCategories from "../../../custom-hooks/useRolesByCategory";
import useUserTypes from "../../../custom-hooks/userUserTypes";

interface IAdvancedAdminUserSearchFilters {
  roleId: number;
  userType: string;
}

interface IAdvancedAdminUserSearchModalProps {
  onCloseModal: () => void;
  dataRecord: {
    onApply: (filters: IAdvancedAdminUserSearchFilters) => void;
    onClear: () => void;
  };
}

const AdvancedAdminUserSearchModal = ({
  onCloseModal,
  dataRecord,
}: IAdvancedAdminUserSearchModalProps) => {
  const [categoryId, setCategoryId] = useState<number | null>(null);
  const [roleId, setRoleId] = useState<number>(0);
  const [userType, setUserType] = useState<string>("");

  const dispatch = useDispatch();

  const { data: roleCategories } = useAllRoleCategories();
  const { data: rolesbyCategory, isLoading: isLoadingRoles } =
    useAllRoleByCategories(categoryId);
  const { data: userTypeObject } = useUserTypes();

  const cleanupCategoryList = (
    list: { id: number; name: string }[] | undefined,
  ) => {
    if (!list || list.length === 0) return [];
    return list.map((item) => ({ label: item.name, value: item.id }));
  };

  const cleanupRoleList = (
    list: { id: number; name: string }[] | undefined,
  ) => {
    if (!list || list.length === 0) return [];
    return list.map((item) => ({ label: item.name, value: item.id }));
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    dataRecord.onApply({ roleId, userType });
    dispatch(hideModal());
  };

  const handleClear = () => {
    dataRecord.onClear();
    dispatch(hideModal());
  };

  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      <div className="LoanModal Modal__content">
        <div
          className="Modal__body"
          style={{ overflow: "visible", minHeight: "280px" }}
        >
          <React.Fragment>
            <h3 className="Modal__title p-b-1">Advanced Search</h3>
            <div id="advanced-admin-user-search">
              <div className="m-b-30">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-4 col-sm-12 mt-2">
                      <label>Role Category:</label>
                      <CustomSearchDropDown
                        placeholder="Select role category"
                        defaultOptions={cleanupCategoryList(roleCategories)}
                        inputWidth={100}
                        onChange={(selected: {
                          label: string;
                          value: number;
                        }) => {
                          setCategoryId(selected?.value ?? null);
                          setRoleId(0);
                        }}
                        isSearchable={false}
                        inputHeight={48}
                      />
                    </div>

                    <div className="col-md-4 col-sm-12 mt-2">
                      <label>Role:</label>
                      {isLoadingRoles ? (
                        <div style={{ marginTop: "0.5rem" }}>
                          <ButtonLoader />
                        </div>
                      ) : (
                        <CustomSearchDropDown
                          placeholder="Filter by role"
                          defaultOptions={cleanupRoleList(
                            rolesbyCategory?.roles,
                          )}
                          inputWidth={100}
                          onChange={(selected: {
                            label: string;
                            value: number;
                          }) => {
                            setRoleId(selected?.value ?? 0);
                          }}
                          isSearchable={false}
                          disabled={!categoryId}
                          inputHeight={48}
                        />
                      )}
                    </div>

                    <div className="col-md-4 col-sm-12 mt-2">
                      <label>User Type:</label>
                      <select
                        className="form-control"
                        value={userType}
                        onChange={(e) => setUserType(e.target.value)}
                      >
                        <option value="">All</option>
                        {userTypeObject?.data?.length > 0 &&
                          userTypeObject.data.map(
                            (_userType: { id: number; name: string }) => (
                              <option key={_userType.id} value={_userType.name}>
                                {_userType.name}
                              </option>
                            ),
                          )}
                      </select>
                    </div>
                  </div>

                  <div className="Form__action-buttons m-t-2">
                    <button
                      type="submit"
                      className="btn zoom-element btn login-btn m-0 mr-auto"
                    >
                      <i className="fa fa-check-circle" /> Search
                    </button>
                    <button
                      type="button"
                      onClick={handleClear}
                      className="btn zoom-element btn login-btn m-0 ml-auto"
                    >
                      <i className="fa fa-times-circle" /> Clear
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </React.Fragment>
        </div>
      </div>
    </div>
  );
};

export default AdvancedAdminUserSearchModal;
